import MessagingBanner from './MessagingBanner.component';

export default MessagingBanner;
